<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle background"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}">
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="logo.png" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://www.takiritravel.com/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <span class="custom-logo" width="180" height="50"></span>
        </a>
        <div class="containerMenu navbar-collapse collapse" style="flex-basis: 0%;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://www.takiritravel.com/about-us/" target="_blank">About
                        us</a></li>
                <li class="nav-item menuItem"><a href="https://www.takiritravel.com/destinations/"
                        target="_blank">Destinations</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.takiritravel.com/tours/" target="_blank">Tours</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.takiritravel.com/blog-travel-ecuador/"
                        target="_blank">Blogs &
                        News</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.takiritravel.com/faq/" target="_blank">FAQ</a>
                </li>
                <li class="nav-item menuItem"><a
                        href="https://www.takiritravel.com/contact-takiri-travel-agency-quito-ecuador/"
                        target="_blank">Contact Us</a>
                </li>
            </ul>
        </div>
        <div class="button-container">
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>


    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex; align-items: center; justify-content: space-between;">
            <img src="../assets/images/logos-header/tt.png" width="129" />
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()">
                <i class="fa fa-bars fa-2x"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/about-us/" target="_blank">About us</a></li>
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/destinations/"
                target="_blank">Destinations</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/tours/" target="_blank">Tours</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/blog-travel-ecuador/" target="_blank">Blogs
                &
                News</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/faq/" target="_blank">FAQ</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.takiritravel.com/contact-takiri-travel-agency-quito-ecuador/"
                target="_blank">Contact Us</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>

</nav>